import { Button } from "./Button";

interface FooterButtonsProps {
  primaryOnClick: () => void;
  secondaryOnClick?: () => void;
  primaryText: string;
  secondaryText?: string;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
  position?: "start" | "end" | "center" | "between" | "around";
  className?: string;
  isReverse?: boolean;
}
const FooterButtons = ({
  primaryOnClick,
  secondaryOnClick,
  primaryText = "Save",
  secondaryText = "Cancel",
  primaryDisabled = false,
  secondaryDisabled = false,
  position = "end",
  className,
  isReverse = false,
}: FooterButtonsProps) => {
  const btnPosition = isReverse
    ? position === "end"
      ? "start"
      : "end"
    : position;
  return (
    <div
      className={`flex items-center justify-${btnPosition} gap-3 ${className} ${
        isReverse ? "flex-row-reverse" : ""
      }`}
    >
      {secondaryText && (
        <Button
          text={secondaryText}
          variant={isReverse ? "contained" : "outlined"}
          color={isReverse ? "primary" : "gray"}
          onClick={secondaryOnClick}
          disabled={secondaryDisabled}
        />
      )}
      <Button
        type="submit"
        variant={isReverse ? "outlined" : "contained"}
        color={isReverse ? "gray" : "primary"}
        text={primaryText}
        onClick={primaryOnClick}
        disabled={primaryDisabled}
      />
    </div>
  );
};

export { FooterButtons };
